import React from 'react'
import get from 'lodash/get'
import convert from 'color-convert'

import { Status as StatusComponent } from '@infotech/base-components'

const isBorderNeed = (color) => (
  get(convert.hex.gray(color), `0`) > 90
)

const hintText = `связанной заявки`

const emptyData = `Нет данных`

const IssueLinkIssueType = ({ typeName }) => (
  <div>
    <div className="text-muted">Тема заявки: </div>
    <div>{typeName || emptyData}</div>
  </div>
)

const IssueLinkIdFormatter = ({ issueNumber }) => (
  <div
    title={`Номер ${hintText}`}
    className="issue-link-widget-infoblock__issue-link-id-formatter"
  >
    {issueNumber}
  </div>
)

const StatusFormatter = ({
  status,
}) => (
  <div
    title={`Статус ${hintText}`}
    className="issue-link-widget-infoblock__status-formatter"
  >
    <StatusComponent
      name={get(status, `name`)} color={get(status, `color`)}
      withBorder={isBorderNeed(get(status, `color`))}
    />
  </div>
)

const KisurComponent = ({ externalIdentifier = `Нет данных` }) => (
  <div>
    <div className="text-muted">Номер заказа из Кисур: </div>
    <div>{externalIdentifier || emptyData}</div>
  </div>
)

const ToirIssueLinkInfoblock = ({
  issueLink: {
    status,
    id,
    summary,
    issueNumber = id,
    customFields,
  },
}) => (
  <div className="issue-link-widget-infoblock">
    <div className="issue-link__row">
      <IssueLinkIdFormatter issueNumber={issueNumber} />
    </div>
    <div className="issue-link__row">
      <StatusFormatter status={status} />
    </div>
    <KisurComponent externalIdentifier={get(customFields, `external_identifier`)} />
    <IssueLinkIssueType typeName={summary} />
  </div>
)

export default ToirIssueLinkInfoblock
